import { CrudModel } from "../plugins/Cruxtify/CrudModel";
import { StringField } from "../plugins/Cruxtify/field-types/StringField";
import {
  BooleanProperty,
  DateTimeProperty,
  NumberProperty,
  StringProperty,
} from "../plugins/Cruxtify/property-types";

import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { WysiwygField } from "../plugins/Cruxtify/field-types";
import { extendWithDeleted } from "./collection-layouts/extend-with-deleted";

export class MailerTemplate extends CrudModel {
  protected static _typeLabel = "Mailer Template";
  protected static asProperty = "mailer_template";
  public static api = {
    path: "mailer-templates",
  };

  protected userIdField = [];
  protected static routeBase = "mailer-templates";

  protected labelGlue: string = " ";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
    },
    UserPermission.Hidden
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "Entry Deleted At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },

    { type: StringProperty, opts: { name: "name", label: "Name" } },
    { type: StringProperty, opts: { name: "slug", label: "Slug" } },
    { type: StringProperty, opts: { name: "subject", label: "Subject" } },
    { type: StringProperty, opts: { name: "content", label: "Content" } },
    {
      type: BooleanProperty,
      opts: { name: "is_system", label: "System Template" },
    },
  ];

  protected static fieldDefinitions = [
    {
      type: "NumberField",
      opts: {
        property: "id",
      },
    },
    {
      type: "DateTimeField",
      opts: {
        property: "created_at",
        label: "Saved At",
      },
    },
    {
      type: "DateTimeField",
      opts: {
        property: "updated_at",
      },
    },
    {
      type: "DateTimeField",
      opts: {
        property: "deleted_at",
      },
    },

    {
      type: StringField,
      opts: { property: "name", isPrimaryLabelField: 1, cols: 12 },
    },
    {
      type: StringField,
      opts: {
        property: "name",
        id: "merge_tags",
        label: "",
        viewComponentName: "merge-tags-reference",
        formComponentName: "merge-tags-reference",
      },
    },
    {
      type: StringField,
      opts: {
        property: "name",
        id: "preview_email",
        label: "",
        viewComponentName: "mailer-template-preview",
        formComponentName: "mailer-template-preview",
      },
    },
    {
      type: StringField,
      opts: {
        property: "slug",
        conditional: {
          property: "is_system",
          value: false,
        },
      },
    },
    { type: StringField, opts: { property: "subject", cols: 12 } },
    { type: WysiwygField, opts: { property: "content" } },
  ];

  protected static collectionLayoutDefinitions = extendWithDeleted([
    {
      id: "table",
      inlineEdit: false,
      columnFields: ["name"],
      filterFields: [],
      useModal: true,
      noNew: true,
      noRefresh: true,
      searchLabel: "Search",
      defaultSort: [
        // {
        //   field: "series",
        //   order: "asc"
        // },
        // {
        //   field: "step_num",
        //   order: "asc"
        // }
      ],
    },
  ]);

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "default",
        fieldSets: [
          { id: "meta", fields: ["name", "slug", "created_at", "updated_at"] },
          {
            id: "email",
            fields: ["merge_tags", "preview_email", "subject", "content"],
          },
        ],
      },
    },
  ];

  public static getMergeTags() {
    return this.$nuxt.$api.GET("merge-tags").then((res) => {
      if (res.data) return res.data;

      return res;
    });
  }

  public static getPreview(id) {
    return this.$nuxt.$api
      .GET(`mailer-templates/${id}/preview`)
      .then((res) => res.data ?? res);
  }
}
